/* CANIPANI — Panier AJAX & tiroir latéral
   Intercepte tous les formulaires .shopify-product-form, ajoute au panier via
   /cart/add.js, puis diffuse `cart:item-added` pour ouvrir et rafraîchir le
   tiroir. Aucun rechargement de page. */

(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';

  function moneyRefresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION_ID, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return null;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer-inner]');
        var current = document.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return parsed;
      })
      .catch(function () { return null; });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function refreshCartState() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        return cart;
      })
      .catch(function () { return null; });
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: 'cart-drawer' } }));
  }

  function setLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  function showError(form, message) {
    var slot = form.querySelector('[data-form-error]');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
  }

  function clearError(form) {
    var slot = form.querySelector('[data-form-error]');
    if (!slot) return;
    slot.hidden = true;
    slot.textContent = '';
  }

  function handleSubmit(event) {
    var form = event.target.closest('.shopify-product-form');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    clearError(form);
    setLoading(button, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function (item) {
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: item }));
        return Promise.all([moneyRefresh(), refreshCartState()]);
      })
      .then(function () { openDrawer(); })
      .catch(function (error) {
        var message = (error && (error.description || error.message)) ||
          form.getAttribute('data-error-text') || 'Ajout impossible. Merci de réessayer.';
        showError(form, message);
      })
      .then(function () { setLoading(button, false); });
  }

  document.addEventListener('submit', handleSubmit);

  /* Modification de quantité et suppression dans le tiroir et la page panier */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-change]');
    if (!trigger) return;
    event.preventDefault();

    var line = trigger.getAttribute('data-line');
    var quantity = trigger.getAttribute('data-cart-change');

    trigger.setAttribute('aria-busy', 'true');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return null;
        }
        return moneyRefresh();
      })
      .catch(function () {})
      .then(function () { trigger.removeAttribute('aria-busy'); });
  });

  document.addEventListener('cart:item-added', function () {
    document.querySelectorAll('[data-cart-empty]').forEach(function (el) { el.hidden = true; });
  });
})();
